import axios from "axios";
import React, { useEffect, useState } from "react";
import { languageOptions } from "../constants/languageOptions";
import CodeEditorWindow from "./CodeEditorWindow";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FooterTwo from "../../../components/FooterTwo";
import HeaderTwo from "../../../components/HeaderTwo";
import '../AppCode.css';
import useKeyPress from "../hooks/useKeyPress";
import '../indexCode.css';
import { defineTheme } from "../lib/defineTheme";
import CustomInput from "./CustomInput";
import LanguagesDropdown from "./LanguagesDropdown";
import OutputDetails from "./OutputDetails";
import OutputWindow from "./OutputWindow";
import ThemeDropdown from "./ThemeDropdown";

const javascriptDefault = `/**
* Practice Coding here ...
*/


`;

const Landing = () => {
  const [code, setCode] = useState(javascriptDefault);
  const [customInput, setCustomInput] = useState("");
  const [outputDetails, setOutputDetails] = useState(null);
  const [processing, setProcessing] = useState(null);
  const [theme, setTheme] = useState("cobalt");
  const [language, setLanguage] = useState(languageOptions[0]);

  const enterPress = useKeyPress("Enter");
  const ctrlPress = useKeyPress("Control");

  const onSelectChange = (sl) => {
    console.log("selected Option...", sl);
    setLanguage(sl);
  };

  useEffect(() => {
    if (enterPress && ctrlPress) {
      console.log("enterPress", enterPress);
      console.log("ctrlPress", ctrlPress);
      handleCompile();
    }
  }, [ctrlPress, enterPress]);
  const onChange = (action, data) => {
    switch (action) {
      case "code": {
        setCode(data);
        break;
      }
      default: {
        console.warn("case not handled!", action, data);
      }
    }
  };
  const handleCompile = () => {
    setProcessing(true);
    const formData = {
      language_id: language.id,
      // encode source code in base64
      source_code: btoa(code),
      stdin: btoa(customInput),
    };
    const options = {
      method: "POST",
      url: 'https://judge0-ce.p.rapidapi.com/submissions',
      params: { base64_encoded: "true", fields: "*" },
      headers: {
        "content-type": "application/json",
        "Content-Type": "application/json",
        "X-RapidAPI-Host":'judge0-ce.p.rapidapi.com',
        "X-RapidAPI-Key": 'f0857d3b80msh16a216a137ba580p1a090ajsn04ca1c029c49',
      },
      data: formData,
    };

    axios
      .request(options)
      .then(function (response) {
        console.log("res.data", response.data);
        const token = response.data.token;
        checkStatus(token);
      })
      .catch((err) => {
        console.log(err, "check error of the request")
        let error = err.response ? err.response.data : err;
        // get error status
        let status = err.response?.status;
        console.log("status check", status);
        if (status === 429) {
          console.log("too many requests", status);

          showErrorToast(
            `Quota of 100 requests exceeded for the Day! Please read the blog on freeCodeCamp to learn how to setup your own RAPID API Judge0!`,
            10000
          );
        }
        setProcessing(false);
        console.log("catch block...", error);
      });
  };

  const checkStatus = async (token) => {
    const options = {
      method: "GET",
      url:'https://judge0-ce.p.rapidapi.com/submissions' + "/" + token,
      params: { base64_encoded: "true", fields: "*" },
      headers: {
        "X-RapidAPI-Host":'judge0-ce.p.rapidapi.com',
        "X-RapidAPI-Key": 'f0857d3b80msh16a216a137ba580p1a090ajsn04ca1c029c49',
      },
    };
    try {
      let response = await axios.request(options);
      console.log("response await",response)
      let statusId = response.data?.status?.id;

      // Processed - we have a result
      if (statusId === 1 || statusId === 2) {
        // still processing
        setTimeout(() => {
          checkStatus(token);
        }, 2000);
        return;
      } else {
        setProcessing(false);
        setOutputDetails(response.data);
        showSuccessToast(`Compiled Successfully!`);
        console.log("response.data", response.data);
        return;
      }
    } catch (err) {
      console.log("err", err);
      setProcessing(false);
      showErrorToast();
    }
  };

  function handleThemeChange(th) {
    const theme = th;
    console.log("theme...", theme);

    if (["light", "vs-dark"].includes(theme.value)) {
      setTheme(theme);
    } else {
      defineTheme(theme.value).then((_) => setTheme(theme));
    }
  }
  useEffect(() => {
    defineTheme("oceanic-next").then((_) =>
      setTheme({ value: "oceanic-next", label: "Oceanic Next" })
    );
  }, []);

  const showSuccessToast = (msg) => {
    toast.success(msg || `Compiled Successfully!`, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const showErrorToast = (msg, timer) => {
    toast.error(msg || `Something went wrong! Please try again.`, {
      position: "top-right",
      autoClose: timer ? timer : 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

       <HeaderTwo />

     <div className="row p-0 m-0" style={{zIndex:"9999"}}>
        <div className="col-sm-12 col-md-4 col-lg-2 pt-3 ">
          <LanguagesDropdown onSelectChange={onSelectChange} />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-2 pt-3">
          <ThemeDropdown handleThemeChange={handleThemeChange} theme={theme} />
        </div>
      </div>
       <div className="row p-0 mx-0 my-3" style={{overflow:'hidden',zIndex:"9999"}}>
        <div className="col-lg-8 mt-3">
          <CodeEditorWindow
            code={code}
            onChange={onChange}
            language={language?.value}
            theme={theme.value}
          />
        </div>

        <div className="col-lg-4 mt-3 text-light" style={{zIndex:"9999"}}>
          <OutputWindow outputDetails={outputDetails} />
          <div >
            <CustomInput
              customInput={customInput}
              setCustomInput={setCustomInput}
            />
            <div style={{textAlign:'right',marginRight:'20px'}}>
            <button
              onClick={handleCompile}
              disabled={!code}
              className="bg-light text-dark px-4 py-2 rounded" style={{fontWeight:"bold",boxShadow:'4px 4px black'}}
            >
                {processing?'Compiling . . .': 'Execute'}
            </button>
            </div>
          </div>
          {outputDetails && <OutputDetails outputDetails={outputDetails} />}
        </div>
      </div> 
      <FooterTwo />
    </>
  );
};
export default Landing;
